<h3 mat-dialog-title>Активация {{test.type === 'POLL' ? 'опроса' : 'теста'}}</h3>
<div mat-dialog-content>
  <p>Вы действительно хотите активировать {{test.type === 'POLL' ? 'опрос' : 'тест'}}?</p>
  <div class="checks-container">
    <div class="check">
      <div class="title">Проверка вопросов:</div>
      <div *ngIf="!questionsChecked"
           class="spinner-container">
        <mat-spinner [diameter]="25"></mat-spinner>
      </div>
      <ul *ngIf="questionsChecked && questionsErrors.length > 0" class="errors">
        <li *ngFor="let error of questionsErrors">{{error}}</li>
      </ul>
      <div *ngIf="questionsChecked && questionsErrors.length === 0" class="no-errors">
        Проблемы отсутствуют
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button
          (click)="onCancel()">Отмена
  </button>
  <button mat-flat-button color="primary"
          [disabled]="!questionsChecked || questionsErrors.length > 0"
          cdkFocusInitial
          (click)="onSubmit()">Активировать
  </button>
</div>
